import { insuranceVsTermPlusSIP } from "../../engine/calculations";

const config = {
  key: "insurance-vs-term-sip",
  title: "Insurance vs Term Cover + Annual SIP",
  category: "Insurance & Protection",
  description: "Compare a traditional policy against buying pure term cover and investing the premium you save.",
  fields: [
    { key: "traditionalAnnualPremium", label: "Traditional policy annual premium", type: "currency", default: 50_000, min: 500, max: 50_00_000 },
    { key: "cover", label: "Cover amount (same for both options)", type: "currency", default: 1_00_00_000, min: 1_00_000, max: 10_00_00_000 },
    { key: "termAnnualPremium", label: "Term cover annual premium", type: "currency", default: 12_000, min: 500, max: 10_00_000 },
    { key: "sipRate", label: "Expected return on the SIP", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
    { key: "years", label: "Years", type: "number", default: 20, min: 1, max: 40 },
    { key: "traditionalMaturity", label: "Traditional policy maturity value", type: "currency", default: 15_00_000, min: 0, max: 10_00_00_000 },
  ],
  chart: {
    type: "bar",
    xKey: "name",
    series: [{ key: "amount", label: "Amount", colorVar: "--gold" }],
  },
  compute(values) {
    const traditionalAnnualPremium = Number(values.traditionalAnnualPremium) || 0;
    const cover = Number(values.cover) || 0;
    const termAnnualPremium = Number(values.termAnnualPremium) || 0;
    const sipRate = (Number(values.sipRate) || 0) / 100;
    const years = Number(values.years) || 0;
    const traditionalMaturity = Number(values.traditionalMaturity) || 0;

    const result = insuranceVsTermPlusSIP(traditionalAnnualPremium, cover, termAnnualPremium, sipRate, years, traditionalMaturity);
    const betterOption = result.advantage > 0 ? "Term + SIP" : "Traditional policy";

    return {
      headline: { label: "Better option", value: betterOption, format: "text" },
      extraHeadlines: [{ label: "Difference in your favour", value: Math.abs(result.advantage) }],
      breakdown: [
        { label: "Cover amount (same in both options)", value: cover },
        { label: "Term + SIP ends with", value: result.termPlusSipCorpus },
        { label: "Traditional policy ends with", value: result.traditionalMaturity },
      ],
      series: [
        { name: "Term + SIP", amount: result.termPlusSipCorpus },
        { name: "Traditional policy", amount: result.traditionalMaturity },
      ],
    };
  },
};

export default config;
